export default __webpack_public_path__ + "static/media/thumb_up.4396ba2b.svg";